<template>
  <div class="row table-sm mr-0 ml-0 p-0">
    <div class="row table-sm mr-0 ml-0 p-0 mb-3 width-100">
      <div
        class="
          col-7
          p-0
          align-self-center
          font-weight-bold
          d-flex
          align-items-center
          w-reset
          mb-sm-2
        "
      >
        <h5 class="d-inline mr-2 font-weight-bold">
          {{ $t("message.patientResidenceReport") }}
        </h5>
        <crm-refresh @c-click="refresh()"></crm-refresh>
        <div class="text-center d-flex sorddata ml-3">
          <el-input
            size="mini"
            :placeholder="$t('message.search')"
            prefix-icon="el-icon-search"
            v-model="filterForm.search"
            clearable
          ></el-input>
          <el-date-picker
            size="mini"
            v-model="filterForm.start_date"
            type="date"
            :format="'dd.MM.yyyy'"
            :value-format="'dd.MM.yyyy'"
            :placeholder="$t('message.start_date')"
          ></el-date-picker>
          <el-date-picker
            size="mini"
            v-model="filterForm.end_date"
            type="date"
            :format="'dd.MM.yyyy'"
            :value-format="'dd.MM.yyyy'"
            :placeholder="$t('message.end_date')"
          ></el-date-picker>
          <div class="px-2">
            <select-service-inventory
              size="mini"
              v-model="filterForm.service_id"
              :id="filterForm.service_id"
            />
          </div>
        </div>
      </div>
      <div
        class="
          col-5
          align-items-center align-self-center
          text-right
          pr-0
          d-flex
          justify-content-end
          w-reset
        "
      >
        <export-excel
          class="btn excel_btn mr-2"
          :data="reports"
          :fields="excel_fields"
          @fetch="controlExcelData()"
          worksheet="Отчет по районам"
          name="Отчет по районам.xls"
        >
          <el-button size="mini" icon="el-icon-document-delete">
            Excel
          </el-button>
        </export-excel>
        <crm-column-settings
          :columns="columns"
          :modelName="'patientResidenceReport'"
          @c-change="updateColumn"
        ></crm-column-settings>
      </div>
    </div>

    <table class="table table-bordered table-hover" v-loading="loadingData">
      <thead>
        <tr>
          <crm-th
            :column="columns.id"
            :sort="sort"
            @c-change="updateSort"
          />
          <crm-th
            :column="columns.state"
            :sort="sort"
            @c-change="updateSort"
          />
          <crm-th
            :column="columns.region"
            :sort="sort"
            @c-change="updateSort"
          />
          <crm-th
              :column="columns.city"
              :sort="sort"
              @c-change="updateSort"
          />
          <crm-th
            :column="columns.count"
            :sort="sort"
            @c-change="updateSort"
          />
          <crm-th
            :column="columns.total_price"
            :sort="sort"
            @c-change="updateSort"
          />
          <crm-th
            :sort="sort"
            :column="columns.settings"
            @c-change="updateSort"
          />
        </tr>
        <tr>
          <th v-if="columns.id.show">
            <el-input
              clearable
              size="mini"
              class="id_input"
              v-model="filterForm.id"
              :placeholder="columns.id.title"
            ></el-input>
          </th>
          <th v-if="columns.state.show">
            <el-select
              filterable
              clearable
              :placeholder="columns.state.title"
              size="mini"
              v-model="filterForm.state_id"
              @change="updateRegion"
            >
              <el-option
                v-for="item in states"
                :key="item.name + item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </th>
          <th v-if="columns.region.show">
            <el-select
              filterable
              clearable
              :placeholder="columns.region.title"
              size="mini"
              v-model="filterForm.region_id"
              @change="updateCity"
            >
              <el-option
                v-for="item in regions"
                :key="item.name + item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </th>
          <th v-if="columns.city.show">
            <el-select
              filterable
              clearable
              :placeholder="columns.city.title"
              size="mini"
              v-model="filterForm.city_id"
            >
              <el-option
                v-for="item in cities"
                :key="item.name + item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </th>
          <th v-if="columns.count.show"></th>
          <th v-if="columns.settings.show"></th>
        </tr>
      </thead>
      <transition-group name="flip-list" tag="tbody">
        <tr :key="0">
          <td v-if="columns.id.show"></td>
          <td v-if="columns.state.show"></td>
          <td v-if="columns.region.show"></td> <!-- Здесь пусто, т.к. это страна -->
          <td v-if="columns.city.show"></td>
          <td v-if="columns.count.show">{{ list.total_patients ? list.total_patients.orders_count : '' }}</td>
          <td v-if="columns.total_price.show">{{ list.total_patients ? list.total_patients.total_price : '' | formatMoney }}</td>
          <td v-if="columns.settings.show">
            <el-button
              type="primary"
              @click="showServices()"
            >{{ $t(`message.services`) }}</el-button>
          </td>
        </tr>
        <template v-for="(state, stateIndex) in list.states">
          <tr :key="'state-' + state.id">
            <td v-if="columns.id.show">{{ state.id }}</td>
            <td v-if="columns.state.show">{{ state.name || '' }}</td>
            <td v-if="columns.region.show"></td> <!-- Здесь пусто, т.к. это страна -->
            <td v-if="columns.city.show"></td>
            <td v-if="columns.count.show">{{ state.orders_count }}</td>
            <td v-if="columns.total_price.show">{{ state.total_price | formatMoney }}</td>
            <td v-if="columns.settings.show">
              <el-button
                type="primary"
                @click="showServices(state.id)"
              >{{ $t(`message.services`) }}</el-button>
            </td>
          </tr>
          <!-- Вложенный цикл для регионов страны -->
          <template v-for="(region, regionIndex) in state.regions">
            <tr :key="'region-' + region.id">
              <td v-if="columns.id.show">{{ state.id + '-' + region.id }}</td>
              <td v-if="columns.state.show">{{ state.name || '' }}</td>
              <td v-if="columns.region.show">{{ region.name || '' }}</td>
              <td v-if="columns.city.show"></td>
              <td v-if="columns.count.show">{{ region.orders_count }}</td>
              <td v-if="columns.total_price.show">{{ region.total_price | formatMoney }}</td>
              <td v-if="columns.settings.show">
                <el-button
                  type="primary"
                  @click="showServices(state.id, region.id)"
                >{{ $t(`message.services`) }}</el-button>
              </td>
            </tr>
            <tr v-for="(city, cityIndex) in region.cities" :key="'city-' + city.id">
              <td v-if="columns.id.show">{{ state.id + '-' + region.id + '-' + city.id }}</td>
              <td v-if="columns.state.show">{{ state.name || '' }}</td>
              <td v-if="columns.region.show">{{ region.name || '' }}</td>
              <td v-if="columns.city.show">{{ city.name || '' }}</td>
              <td v-if="columns.count.show">{{ city.orders_count }}</td>
              <td v-if="columns.total_price.show">{{ city.total_price | formatMoney }}</td>
              <td v-if="columns.settings.show">
                <el-button
                  type="primary"
                  @click="showServices(state.id, region.id, city.id)"
                >{{ $t(`message.services`) }}</el-button>
              </td>
            </tr>
          </template>
        </template>
      </transition-group>
    </table>
    <el-drawer
      class="popups_title"
      size="60%"
      :wrapperClosable="false"
      :visible.sync="drawer"
      @opened="drawerOpened('cabinet_doctor')"
      :with-header="false"
    >
      <Services
        :selected="selectedModel"
        @c-close="drawer = false"
        ref="services"
      />
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import lists from "@/utils/mixins/list";
import drawer from "@/utils/mixins/drawer";
import {formatMoney} from "@/filters";
import Services from "@/views/patientResidenceReport/components/show.vue";
export default {
  mixins: [lists, drawer],
  components: {
    Services,
  },
  data() {
    return {
      drawerCreateCoculation: false,
      filterForm: {},
      drawerShow: false,
      reopenShow: false,
      reopenUpdate: false,
      excel_data: [],
      excel_fields: {},
      selectedModel: {},
      loadingData: false,
      reports: [],
      drawer: false,
      state: null,
      region: null,
    };
  },
  computed: {
    ...mapGetters({
      list: "patientResidenceReport/list",
      columns: "patientResidenceReport/columns",
      pagination: "patientResidenceReport/pagination",
      filter: "patientResidenceReport/filter",
      sort: "patientResidenceReport/sort",
      states: "states/list",
      regions: "regions/list",
      cities: "cities/list",
    }),
  },
  watch: {
    columns: {
      handler: function () {
        this.controlExcelData();
      },
      deep: true,
    },
  },
  mounted() {
    if (this.states && this.states.length === 0) this.loadStates();
    if (this.cities && this.cities.length === 0) this.loadCities();
    if (this.regions && this.regions.length === 0) this.loadRegions();
  },
  methods: {
    formatMoney,
    ...mapActions({
      updateList: "patientResidenceReport/index",
      updateSort: "patientResidenceReport/updateSort",
      updateFilter: "patientResidenceReport/updateFilter",
      updateColumn: "patientResidenceReport/updateColumn",
      updatePagination: "patientResidenceReport/updatePagination",
      empty: "patientResidenceReport/empty",
      refreshData: "patientResidenceReport/refreshData",
      loadStates: "states/index",
      loadRegions: "regions/index",
      loadCities: "cities/index",
    }),
    async fetchData() {
      if (!this.loadingData) {
        this.loadingData = true;
        await this.updateList()
          .then((res) => {
            this.controlExcelData();
            this.loadingData = false;
          })
          .catch((err) => {
            this.loadingData = false;
          });
      }
    },
    refresh() {
      this.refreshData();
    },
    updateRegion() {
      this.loadRegions({state_id: this.filterForm.state_id});
    },
    updateCity() {
      this.loadCities({region_id: this.filterForm.region_id});
    },
    async showServices(state = null, region = null, city = null) {
      this.selectedModel = {
        'state': state,
        'region': region,
        'city': city,
        'service_id': this.filterForm.service_id
      };
      this.drawer = true;
    },
    drawerOpened(ref) {
      this.$refs.services.afterOpen();
    },
    controlExcelData() {
      const result = [];

      this.list.states.forEach(country => {
        this.reports.push({
          id: country.id,
          country: country.name,
          region: '',
          city: '',
          orders_count: country.orders_count,
          total_price: country.total_price,
        });

        country.regions ? country.regions.forEach(region => {
          this.reports.push({
            id: `${country.id}-${region.id}`,
            country: country.name,
            region: region.name,
            city: '',
            orders_count: region.orders_count,
            total_price: region.total_price,
          });

          region.cities ? region.cities.forEach(city => {
            this.reports.push({
              id: `${country.id}-${region.id}-${city.id}`,
              country: country.name,
              region: region.name,
              city: city.name,
              orders_count: city.orders_count,
              total_price: city.total_price,
            });
          }) : null;
        }) : null;
      });

      // Настройка полей для экспорта в excel
      this.excel_fields = {
        ID: "id",
        "Страна": "country",
        "Регион": "region",
        "Город": "city",
        "Количество": "orders_count",
        "Общая сумма": "total_price",
      };

      return result;
    },
    emptyModel() {
      // this.$refs["createDrawer"].afterClosed();
      this.empty();
    },
  },
};
</script>
<style lang="scss" scoped>
.router_style {
  td {
    padding: 0 !important;
    margin: 0px !important;
    a {
      display: block;
      padding: 0.3rem;
      color: #303030;
      font-weight: 200 !important;
      font-size: 14px !important;
    }
  }
}
</style>



